import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../Login/Login";
import Signout from "../Login/SignOut.js";
import IConnectHome from "../Landing/IConnectHome.js";
import Logout from "../Landing/Logout.js";
import Chatbot from "../ChatBot/Chatbot.js";
import { ToastProvider } from "../../context/ToastContext.jsx";

const MainSection = () => {
  return (
    <BrowserRouter>
      <ToastProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<IConnectHome />} />
          <Route path="/SignOut" element={<Signout />} />
          <Route path="/Logout" element={<Logout />} />
          <Route path="/ChatBot" element={<Chatbot />} />
        </Routes>
      </ToastProvider>
    </BrowserRouter>
  );
};
export default MainSection;
